import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const toThousandth = (val: string | number) =>
  val
    ?.toString()
    .split('.')[0]
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '';

export const toFixed = (value: number, offset = 2) => {
  const number = Number(value);
  if (isNaN(number) || typeof offset !== 'number') return value;

  const rate = 10 ** offset;
  return (Math.round(number * rate) / rate).toFixed(offset);
};

export const formatCurrency = (number: string | number, fixed = 2) => {
  const validNumber = Number(number);
  if (Number.isNaN(validNumber)) return number;

  if (fixed < 1) return toThousandth(validNumber);

  const numberWithFixed = toFixed(validNumber, fixed);
  const [whole, decimal] = String(numberWithFixed).split('.');
  return `${toThousandth(whole)}.${decimal}`;
};
